module.exports = __webpack_public_path__ + "img/h-1.12580926.png";